
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".5","clip-path":"url(#clip0_10725_119)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58.23 11.149a2.813 2.813 0 011.77 2.61V46.24a2.812 2.812 0 01-1.77 2.61L31.043 59.726a2.812 2.812 0 01-2.09 0L1.767 48.851A2.812 2.812 0 010 46.241V13.76a2.813 2.813 0 011.766-2.61L27.911.69l.038-.011 1.005-.405c.671-.27 1.42-.27 2.092 0l1.009.405.038.011L58.23 11.149zM39.015 7.5l-23.078 9.229-9.014-3.604-3.173 1.271v1.5l24.375 9.75v29.708l1.875.75 1.875-.75V25.65L56.25 15.9v-1.5l-3.172-1.271L30 22.354l-9.015-3.604 23.078-9.229L39.014 7.5z","fill":"#A6A9C7"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10725_119"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h60v60H0z"}})])])])
          )
        }
      }
    